import colors from '@atom/styles/colors';

import WeekViewHeaderCell from './WeekViewHeaderCell';

interface Props {
  datesOfWeek: Date[];
}

const styles = {
  daysHeaderWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    flexShrink: 0,
    alignSelf: 'stretch',
    borderBottom: `1px solid ${colors.neutral.ash}`,
    paddingLeft: '1px',
  },
};

const WeekViewHeader = ({ datesOfWeek }: Props) => {
  return (
    <div style={styles.daysHeaderWrapper}>
      {datesOfWeek.map((dayDate, idx) => (
        <WeekViewHeaderCell key={idx} dayDate={dayDate} firstCell={idx === 0} />
      ))}
    </div>
  );
};

export default WeekViewHeader;
